module.exports = __webpack_public_path__ + "angular-feature.2sBniiEi.svg";